<script lang="ts">
  import { _ } from 'svelte-i18n';
  import StatusMark from './StatusMark.svelte';
  type Row = { metric: string; label?: string; unit: string; target: number; actual: number | null; direction: string; group?: string; now?: number | null };
  export let rows: Row[] = [];
  export let actualLabel: string | null = null;
  // A projection for a plan still in progress: short of the target is shown as a quiet note, not a red cross.
  export let projected = false;
  export let targetLabel: string | null = null;
  // Opens Adapt Forecast for a user whose projection is short of (or well past) the target.
  export let onAdapt: (() => void) | null = null;

  $: showNow = rows.some((r) => r.now !== undefined && r.now !== null);

  const num = (v: number, digits: number) => v.toLocaleString(undefined, { maximumFractionDigits: digits, minimumFractionDigits: digits });
  const shown = (r: Row, v: number | null) => (v === null || v === undefined ? '–' : r.unit === 'J' ? num(v / 1000, 1) : num(v, r.unit === 'W' ? 0 : 1));
  const unitText = (r: Row) => (r.unit === 'J' ? 'kJ' : r.unit);
  function passes(r: Row): boolean | null {
    if (r.actual === null || r.actual === undefined) return null;
    return r.direction === 'AT_MOST' ? r.actual <= r.target : r.actual >= r.target;
  }
</script>

<table class="w-full text-sm">
  <thead>
    <tr class="text-left text-zinc-500">
      <th class="font-normal py-1">{$_('report.table.measure')}</th>
      {#if showNow}<th class="font-normal py-1 pl-8 text-right">{$_('report.table.now')}</th>{/if}
      <th class="font-normal py-1 text-right {showNow ? 'pl-8' : ''}">{targetLabel ?? $_('report.table.target')}</th>
      <th class="font-normal py-1 pl-8 text-right">{actualLabel ?? $_('report.table.actual')}</th>
      <th class="w-8" />
    </tr>
  </thead>
  <tbody>
    {#each rows as r}
      {@const p = passes(r)}
      <tr class="border-t">
        <td class="py-1.5">{r.label ?? r.metric}</td>
        {#if showNow}<td class="py-1.5 pl-8 text-right tabular-nums whitespace-nowrap">{shown(r, r.now ?? null)} {unitText(r)}</td>{/if}
        <td class="py-1.5 text-right tabular-nums whitespace-nowrap {showNow ? 'pl-8' : ''}">{shown(r, r.target)} {unitText(r)}</td>
        <td class="py-1.5 pl-8 text-right tabular-nums whitespace-nowrap">{shown(r, r.actual)} {unitText(r)}</td>
        <td class="py-1.5 text-center"><StatusMark status={p === null ? 'unknown' : p ? 'ok' : projected ? 'short' : 'miss'} reached={projected ? $_('report.table.on_track') : $_('report.table.reached')} /></td>
      </tr>
    {:else}
      <tr><td colspan="5" class="py-2 text-zinc-500">{$_('report.table.not_recorded')}</td></tr>
    {/each}
    {#if onAdapt && rows.length}
      <tr><td colspan={showNow ? 5 : 4} class="pt-1 pb-2 text-right"><button type="button" class="inline-block rounded border border-blue-600 px-2 py-0.5 text-xs font-medium text-blue-600 hover:bg-blue-50 whitespace-nowrap bg-transparent" on:click={onAdapt}>{$_('report.table.adapt')}</button></td></tr>
    {/if}
  </tbody>
</table>
